
let reordered = false;

export const reverseCargoGlideOptions = {
    key: "reverse-cargoglide-options",
    init: (value) => {
        if(value) {
            const productOptions = document.querySelector("product-options");
            let observer = new MutationObserver(checkOptions);
            if(productOptions){
                observer.observe(productOptions, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
}

function checkOptions() {

    if (reordered) {
        reordered = false;
        return
    }

    const extensionEl = document.querySelector("[data-option='CargoGlide Extension'] .optionValues");
    const payloadEl = document.querySelector("[data-option='CargoGlide Payload'] .optionValues");

    if (extensionEl) {
        reordered = true;
        reverseOptions(extensionEl);
    }
    if (payloadEl) {
        reordered = true;
        reverseOptions(payloadEl);
    }
}

// reverse options in the container
function reverseOptions(container) {
    const options = container.querySelectorAll(".optionValue");
    const optionsArray = Array.from(options);
    optionsArray.reverse();
    container.innerHTML = "";
    optionsArray.forEach((option) => {
        container.appendChild(option);
    });
}